import React, { useMemo } from 'react'

import { Text } from '@wartek-id/text-v1'

import { useKinerjaError } from 'app/KinerjaShared/components/KinerjaErrorBoundary/constants'
import KinerjaLayoutBase from 'app/KinerjaShared/components/KinerjaLayoutBase'
import KinerjaError from 'app/KinerjaShared/components/KinerjaErrorBoundary/KinerjaError'
import { CustomError } from 'utils/customError'

import type { TFallbackProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { KinerjaLayoutBase as KinerjaLayoutBaseProps } from 'types/kinerja-layout'

type KinerjaErrorBoundaryProps = TFallbackProps & {
  layoutProps: KinerjaLayoutBaseProps
}

export const KinerjaErrorBoundary = ({
  layoutProps,
  ...props
}: KinerjaErrorBoundaryProps) => {
  const { ERRORS } = useKinerjaError()

  const error = ERRORS.find((error) => props.error instanceof error.errorType)

  if (!error) {
    // if it is not an error that we know, throw it
    // so that it can be handled by the global error boundary
    throw props.error
  }

  const [title, description] = useMemo(() => {
    let title = error?.title
    let description = error.hasOwnProperty('children')
      ? error?.children(props.error as any)
      : ''

    if (props.error instanceof CustomError) {
      if (!title) title = props?.error?.title
      if (!description)
        description = (
          <Text variant="body-lg" color="subdued">
            {props?.error?.description}
          </Text>
        )
    } else if (props.error instanceof Error) {
      if (!title) title = 'Terjadi kesalahan'
      if (!description)
        description = (
          <Text variant="body-lg" color="subdued">
            {props?.error?.message}
          </Text>
        )
    }

    return [title, description]
  }, [error, props.error])

  return (
    <>
      <KinerjaLayoutBase {...layoutProps} centered={false}>
        <KinerjaError
          title={title}
          icon={error.icon}
          ctaAction={error.ctaAction}
          secondaryCtaAction={error.secondaryCtaAction}
        >
          {description}
        </KinerjaError>
      </KinerjaLayoutBase>
    </>
  )
}
